// @ts-nocheck
import type React from 'react';
import MaskedInput from 'react-text-mask';

import type { InputProps } from '@material-ui/core/Input';

import Icon from '@cobliteam/ui/icons';

import { DefaultInput } from '../DefaultInput';

interface DateInputProps extends InputProps {
  error?: boolean;
  inputRef?: (ref?: HTMLElement) => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const MaskInput = (props: DateInputProps) => {
  const { inputRef, value, defaultValue, placeholder, ...otherProps } = props;

  return (
    <MaskedInput
      {...otherProps}
      value={value as string}
      defaultValue={defaultValue as string}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholder={placeholder || 'DD/MM/AAAA'}
      ref={(ref) => {
        if (inputRef && ref) {
          inputRef(ref.inputElement);
        }
      }}
    />
  );
};

/* eslint-disable-next-line import/prefer-default-export */
export const DateInput: React.FC<DateInputProps> = (props) => <DefaultInput startAdornment={<Icon name='calendar-days' />} inputComponent={MaskInput} {...props} />;
